export const Error404 = () => (
  <>
    <p>404 Not Found</p>
  </>
);
